import { render, staticRenderFns } from "./ObiTagsInput.vue?vue&type=template&id=c8ff5582&scoped=true&"
import script from "./ObiTagsInput.vue?vue&type=script&lang=js&"
export * from "./ObiTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./ObiTagsInput.vue?vue&type=style&index=0&id=c8ff5582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff5582",
  null
  
)

export default component.exports